import { Module } from '../Module';
/**
 * A class for Components.
 */
export class Component extends Module {
    /** Add a single plugin */
    addPlugin(plugin) {
        if (typeof this._plugins === 'undefined') {
            this._plugins = [];
        }
        this._plugins.push(plugin);
        // eslint-disable-next-line no-param-reassign
        plugin.component = this;
        plugin.init();
    }
    /** Destroy all plugins */
    _destroyPlugins() {
        var _a;
        (_a = this._plugins) === null || _a === void 0 ? void 0 : _a.forEach((plugin) => plugin.destroy());
    }
    /** Destroy the component */
    _destroy() {
        super._destroy();
        this._destroyPlugins();
    }
}
//# sourceMappingURL=index.js.map